var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoardicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4845 17.6602V10.5352H30.1929V17.6602H21.4845ZM11.1929 20.8268V10.5352H19.9012V20.8268H11.1929ZM21.4845 29.5352V19.2435H30.1929V29.5352H21.4845ZM11.1929 29.5352V22.4102H19.9012V29.5352H11.1929ZM12.7762 19.2435H18.3179V12.1185H12.7762V19.2435ZM23.0679 27.9518H28.6095V20.8268H23.0679V27.9518ZM23.0679 16.0768H28.6095V12.1185H23.0679V16.0768ZM12.7762 27.9518H18.3179V23.9935H12.7762V27.9518Z",
    fill: "#6B6C7E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.19287,
    y: 0.535156,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#E1EEF9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardicon);
export default __webpack_public_path__ + "static/media/boardicon.eb6b7f61f96badd899aef7e4f8dba920.svg";
export { ForwardRef as ReactComponent };